import { Button, Divider, Text } from "@mantine/core";
import { IconMail } from "@tabler/icons-react";
import type { ReactNode } from "react";
import { AUTH_IDENTITY_COPY } from "../lib/kyc";

interface Props {
  appleSlot?: ReactNode;
  googleSlot?: ReactNode;
  emailOpen: boolean;
  onChooseEmail: () => void;
  emailFields: ReactNode;
}

export function AuthIdentityChooser({ appleSlot, googleSlot, emailOpen, onChooseEmail, emailFields }: Props) {
  const hasSocial = Boolean(appleSlot || googleSlot);
  return (
    <div className="authIdentityChooser">
      {appleSlot ? <div className="appleAuthChoice">{appleSlot}</div> : null}
      {googleSlot ? <div className="googleAuthChoice">{googleSlot}</div> : null}
      {hasSocial ? (
        <Divider
          className="authIdentityDivider"
          label={
            <Text
              size="xs"
              c="dimmed"
              fw="var(--axio-font-weight-semibold)"
              tt="uppercase"
              style={{ letterSpacing: "var(--axio-letter-spacing-caps)" }}
            >
              {AUTH_IDENTITY_COPY.orLabel}
            </Text>
          }
          labelPosition="center"
        />
      ) : null}
      {emailOpen ? (
        emailFields
      ) : (
        <div data-testid="auth-email-method">
          <Button
            variant="default"
            fullWidth
            className="emailAuthButton"
            leftSection={<IconMail size="var(--axio-unit-20)" />}
            onClick={onChooseEmail}
          >
            {AUTH_IDENTITY_COPY.emailButton}
          </Button>
        </div>
      )}
    </div>
  );
}
